import { useState, useEffect } from "react";
import Holiday, { mapToHolidays } from "../../models/Holiday";
import { formatDateToYYYYMMDD, getFirstDateOfWeek } from "../../lib/date-time/DateUtils";
import { supabase } from "../../services/supabase/SupabaseClient";
import DismissableBanner from "./DismissibleBanner";
import OpeningHours from "./OpeningHours";

const today = new Date();
const mockHolidayData: Holiday[] = [
  {
    id: '1',
    name: "Holy Day",
    description: "",
    observingStartDate: formatDateToYYYYMMDD(today),
    observingEndDate: formatDateToYYYYMMDD(today),
    officialDate: formatDateToYYYYMMDD(today)
  },
];
const isDev = process.env.NODE_ENV === "development";


function HolidayScheduleSection() {
  const [holidayData, setHolidayData] = useState<Holiday[]>([]);

  useEffect(() => {
    let ignore = false;

    const fetchHolidays = async () => {

        // DEV MOCK
        if (isDev) {
            setHolidayData(mockHolidayData);
            return;
        }

      const today = new Date();
      const firstDateOfWeek = getFirstDateOfWeek(today);

      const searchEndDate = new Date(today);
      searchEndDate.setDate(searchEndDate.getDate() + 30);

      const { data, error } = await supabase
        .from("holidays")
        .select("*")
        .gte("observing_end_date", firstDateOfWeek.toISOString())
        .lte("observing_start_date", searchEndDate.toISOString())
        .order("observing_start_date", { ascending: true });

      if (ignore) return;

      if (error) {
        console.error("Failed to fetch holidays:", error);
        return;
      }

      if (!data || data.length === 0) return;

      setHolidayData(mapToHolidays(data));
    };

    fetchHolidays();

    return () => {
      ignore = true;
    };
  }, []);

  return (
    <>
      {holidayData.length > 0 && (
        <DismissableBanner message="📢 We have updated schedule for the upcoming weeks - Please check the Opening Hours section for details." />
      )}

      <OpeningHours holidayData={holidayData} />
    </>
  );
}

export default HolidayScheduleSection;